module.exports = __webpack_public_path__ + "img/logo.ffe364b5.svg";